export default __webpack_public_path__ + "static/footer-mobile-f311ab89e2a890852d15228f56b454e6.svg";